import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=6f84fb9e&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=6f84fb9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84fb9e",
  null
  
)

export default component.exports